<div id="workspace" class="page-layout carded fullwidth inner-scroll">
  <!-- TOP BACKGROUND -->
  <div class="top-bg bg-primary-400"></div>
  <!-- / TOP BACKGROUND -->

  <!-- CENTER -->
  <div class="center">
    <!-- HEADER -->
    <div class="header bg-primary-400 flex space-between items-center">
      <!-- APP TITLE -->
      <div class="flex justify-start items-center">
        <div
          class="workspace-image mr-4 sm:mr-3"
          [@animate]="{
            value: '*',
            params: { delay: '50ms', scale: '0.2' }
          }"
        >
          <img [src]="workspace?.logo_url || placeholder" alt="Logo" />
        </div>

        <div
          class="flex flex-col items-start justify-start text-on-primary-400"
          [@animate]="{
            value: '*',
            params: { delay: '100ms', x: '-25px' }
          }"
        >
          <div class="h2">
            {{ workspace?.name }}
          </div>
          <div class="subtitle">
            <span>{{ 'WORKSPACES.DETAIL.SUBTITLE' | transloco }}</span>
          </div>
        </div>
      </div>
      <!-- / APP TITLE -->
    </div>
    <!-- / HEADER -->

    <!-- CONTENT CARD -->
    <div class="content-card">
      <!-- CONTENT -->
      <ng-content></ng-content>
      <!-- / CONTENT -->
    </div>
    <!-- / CONTENT CARD -->
  </div>
  <!-- / CENTER -->
</div>
